import './details.css'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import axios from 'axios';
import { API_ENDPOINT, HEADER_TOKEN, DEFAULT_BANNER } from '../../constants/constants';

const DURATIONS = [15, 20, 30, 45, 60, 90, 120, 180]

const Details = (props) => {
    const { category, setCategory, subCategory, setSubCategory, banner, setBanner, setS, at, ad, setAt, setAd } = props
    const [loading, setLoading] = useState(false)
    const [cats, setCats] = useState([])
    const [subcats, setSubCats] = useState([])

    const file_inp = useRef()

    const onImgSelect = () => {
        const [file] = file_inp.current.files
        if (file) {
            let fd = new FormData()
            fd.append("image", file)
            setLoading(true)
            axios.post(API_ENDPOINT + 'trainer/upload-image-only', fd, HEADER_TOKEN).then(res => {
                let d = res.data
                setLoading(false)
                if (d.success) { setBanner(d.message) } else { toast(d.message) }
            })
        }
    }
    const addBanner = () => { file_inp.current.click() }

    const goNext = () => {
        if (at === "") toast("Please Enter Assessment title")
        else setS(2)
    }

    useEffect(() => { loadCategories() }, [])
    useEffect(() => { if (category !== "") loadSubCategories() }, [category])

    function loadCategories() {
        axios.get(API_ENDPOINT + 'sam/get-categories-all', HEADER_TOKEN).then(res => {
            let d = res.data
            if (d.success) { setCats(d.message.map(t => t.category)) }
            else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }
    function loadSubCategories() {
        axios.post(API_ENDPOINT + 'sam/get-subcategories', { category: category }, HEADER_TOKEN).then(res => {
            let d = res.data
            if (d.success) { setSubCats(d.message.map(t => t.topic)) }
            else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }

    const hasBanner = banner && banner !== DEFAULT_BANNER

    return (
        <div>
            <input onChange={onImgSelect} ref={file_inp} type="file" accept="image/*" style={{ display: 'none' }} />
            <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 22 }}>

                {/* DETAILS */}
                <div style={{ background: 'var(--color-surface)', padding: 22 }}>
                    <h4 style={{ margin: '0 0 16px' }}>Mocktest details</h4>
                    <div className="field" style={{ marginBottom: 16 }}>
                        <label>Assessment title</label>
                        <input className="input" value={at} onChange={e => setAt(e.target.value)} placeholder="e.g. SSC CGL 2026 · Full Mock #12" />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
                        <div className="field">
                            <label>Category</label>
                            <select className="input" value={category} onChange={e => { setCategory(e.target.value); setSubCategory("") }}>
                                <option value="">Select category</option>
                                {cats.map((c, i) => <option key={i} value={c}>{c}</option>)}
                            </select>
                        </div>
                        <div className="field">
                            <label>Sub-category</label>
                            <select className="input" value={subCategory} disabled={category === ""} onChange={e => setSubCategory(e.target.value)}>
                                <option value="">{category === "" ? "Select a category first" : "Select sub-category"}</option>
                                {subcats.map((c, i) => <option key={i} value={c}>{c}</option>)}
                            </select>
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                        <div className="field">
                            <label>Duration (minutes)</label>
                            <select className="input" value={ad} onChange={e => setAd(Number(e.target.value))}>
                                {DURATIONS.map(d => <option key={d} value={d}>{d} minutes</option>)}
                            </select>
                        </div>
                    </div>
                </div>

                {/* BANNER */}
                <div style={{ background: 'var(--color-surface)', padding: 22, display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ margin: '0 0 16px' }}>Banner</h4>
                    <div
                        onClick={addBanner}
                        style={{
                            flex: 1, minHeight: 180, border: '2px dashed var(--color-divider)', display: 'flex',
                            flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10,
                            color: 'var(--color-neutral-500)', cursor: 'pointer', overflow: 'hidden', padding: 8,
                        }}
                    >
                        {loading ? (
                            <div style={{ fontSize: 13 }}>Uploading…</div>
                        ) : hasBanner ? (
                            <>
                                <img src={banner} alt="Banner preview" style={{ maxHeight: 150, maxWidth: '100%', objectFit: 'contain' }} />
                                <div style={{ fontSize: 12 }}>Click to replace</div>
                            </>
                        ) : (
                            <>
                                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" x2="12" y1="3" y2="15" /></svg>
                                <div style={{ fontSize: 13 }}>Drop an image or browse</div>
                            </>
                        )}
                    </div>
                    <button className="btn btn-primary" style={{ justifyContent: 'space-between', marginTop: 16 }} onClick={goNext}>
                        Continue to random selection
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
                    </button>
                </div>
            </div>
        </div>
    )
}
export default Details
